// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6f8beab9","453":"855a5202"}[chunkId] + ".chunk.js";
};